import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthGuard } from '../../../services/canactivate.service';
import { WebserviceService } from '../../../services/webservice.service';
import { DatatransferService } from '../../../services/datatransfer.service';

declare var $: any;

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {

  showVaveMenu: boolean;

  constructor(
    public AuthGuard: AuthGuard,
    private route: ActivatedRoute,
    private router: Router,
    public makeapi: WebserviceService,
    public getdata: DatatransferService
  ) {}

  ngOnInit() {
    // Support page is static — no data loading required
  }

  toggleVaveMenu() {
    this.showVaveMenu = !this.showVaveMenu;
  }

}